import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import fr from "date-fns/locale/fr";
import "react-datepicker/dist/react-datepicker.css";
import "./DateField.scss";

registerLocale("es", es);
registerLocale("fr", fr);

export class DateField extends React.Component {
  static defaultProps = {
    defaultValue: "",
    locale: "en",
  };

  static propTypes = {
    /** Additional classNames to add to the Datefield */
    className: PropTypes.string,
    /** The default value of the DateField */
    defaultValue: PropTypes.oneOfType([
      PropTypes.instanceOf(Date),
      PropTypes.string,
    ]),
    /** Use moment.js date formats to change how the selected date is represented */
    dateFormat: PropTypes.string,
    /** The ID of the input */
    id: PropTypes.string,
    /** The label string of the input */
    label: PropTypes.string,
    /** The locale of the component */
    locale: PropTypes.oneOf(["en", "fr", "es"]),
    /** A callback function for when the DateField is changed */
    onChange: PropTypes.func,
    /** Whether the DateField is open or closed when rendered */
    open: PropTypes.bool,
    /** Display a message when no date is selected */
    placeholder: PropTypes.string,
    /** Sets the value so it can be controlled by outer component */
    value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  };

  constructor(props) {
    super(props);

    this.state = {
      value: props.defaultValue || props.value || "",
    };
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;

    this.updateValueStateIfPropChanged(value, prevProps.value);
  }

  updateValueStateIfPropChanged = (newValue, previousValue) => {
    if (newValue !== previousValue) {
      if (newValue) {
        this.setState({ value: newValue });
      } else {
        this.setState({ value: "" });
      }
    }
  };

  onChange = (value) => {
    const { id, onChange } = this.props;
    this.setState({ value });

    if (onChange) {
      if (id) {
        return onChange({
          id,
          value,
        });
      }
      return onChange(value);
    }
    return value;
  };

  render() {
    const { value } = this.state;
    const { className, dateFormat, id, label, locale, open, placeholder } =
      this.props;

    const fieldClass = classNames("date-field-wrapper", className);

    return (
      <div className={fieldClass}>
        {label && <label htmlFor={id}>{label}</label>}
        <DatePicker
          autoComplete="off"
          id={id}
          locale={locale}
          onChange={this.onChange}
          open={open}
          selected={value}
          showYearDropdown
          dateFormatCalendar="MMMM"
          yearDropdownItemNumber={15}
          scrollableYearDropdown
          dateFormat={dateFormat}
          placeholderText={placeholder}
        />
      </div>
    );
  }
}
